
import { useResumeState } from "./useResumeState";

/**
 * Hook for managing resume preview functionality
 */
export const useResumePreview = () => {
  const { setSelectedResume, setShowPreview } = useResumeState();

  const handlePreview = (resume: any) => {
    setSelectedResume(resume);
    setShowPreview(true);
  };

  return { handlePreview };
};
